/** Session key for carrying email from forgot-password step 1 → step 2 (same flow as the app). */
export const FORGOT_PASSWORD_EMAIL_SESSION_KEY = "microlab_forgot_password_email";
